import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import type { AppState } from '~/reducers';
import HybridWebView from '../utils/HybridWebView';
import { clearNativeCommand } from '../store/reducer';

export const useNativeAppDispatcher = () => {
  const nativeCommand = useSelector((state: AppState) => state.native.nativeCommands?.[0]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (nativeCommand) {
      HybridWebView.SendInvokeMessageToDotNet(nativeCommand.name, nativeCommand.params);
      dispatch(clearNativeCommand());
    }
  }, [dispatch, nativeCommand]);
};
